/**
 * Action enum for the Permission Access Layer (SA-1592 Phase A0).
 *
 * `ACTION` is the layer's vocabulary of permission verbs. It is intentionally
 * distinct from the BE permission flag strings (`can_create`, `can_read`, ...)
 * persisted on each menu object — `ACTION` is what callers pass to gates/hooks;
 * the flag string is what lives on the data.
 *
 * `ACTION_FLAG` maps each action to the camelCase boolean prop exposed by the
 * `usePermission` flat return (`canCreate`, `canRead`, ...). It is the public
 * mapping consumed by `Can` and `usePermission`.
 *
 * `ACTION_BE_FLAG` maps each action to the snake_case key actually present on a
 * resolved menu object (the raw BE shape). Pure resolvers that read the menu
 * object directly (e.g. `routeIfAllowed`) use this map.
 */

export const ACTION = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  APPROVE: 'APPROVE',
  READ_ALL: 'READ_ALL',
};

// Action → camelCase flag prop on the usePermission flat return.
export const ACTION_FLAG = {
  [ACTION.CREATE]: 'canCreate',
  [ACTION.READ]: 'canRead',
  [ACTION.UPDATE]: 'canUpdate',
  [ACTION.DELETE]: 'canDelete',
  [ACTION.APPROVE]: 'canApprove',
  [ACTION.READ_ALL]: 'canReadAll',
};

// Action → snake_case key on the raw BE menu object (e.g. menu.can_read).
// Used by pure resolvers that inspect the menu object directly.
export const ACTION_BE_FLAG = {
  [ACTION.CREATE]: 'can_create',
  [ACTION.READ]: 'can_read',
  [ACTION.UPDATE]: 'can_update',
  [ACTION.DELETE]: 'can_delete',
  [ACTION.APPROVE]: 'can_approve',
  [ACTION.READ_ALL]: 'can_read_all',
};
